import React from 'react';
import { Drawer } from 'antd';
import { useAppSelector } from '@/store/hooks';
// import { get_date } from '@/service/formatter/date';
import PretestResults from './PretestAnswer';
// import axiosInstance from '@/utility/axiosInstance';

// interface DescriptionItemProps {
//   title: string;
//   content: React.ReactNode;
//   className?: string;
// }

// const DescriptionItem: React.FC<DescriptionItemProps> = ({
//   title,
//   content,
//   className
// }) => (
//   <div className={`site-description-item-profile-wrapper ${className}`}>
//     <p className="site-description-item-profile-p-label">
//       <span className="font-semibold">{title}:</span>
//     </p>
//     {content}
//   </div>
// );
// interface Candidate {
//   id: string;
//   name: string;
//   email: string;
//   avatar: string;
// }

// interface ApiResponse {
//   message: string;
//   data: {
//     candidate: Candidate;
//     responses: Response[];
//     pretest: Pretest;
//   };
// }

// interface Pretest {
//   id: string;
//   job_title: string;
//   started_at: Date;
//   completed_at: Date;
//   status: string;
//   time_taken: string;
// }

type IDescriptionProps = {
  show: boolean;
  user_id: string;
  id: string;
  onClose: () => void;
};

const DrawerPretest: React.FC<IDescriptionProps> = ({
  show,
  user_id,
  id,
  onClose
}) => {
  const pretests = useAppSelector(({ order }) => order.pretests);

  // Filter to show only the pretest for the specific id
  const selectedPretest = pretests?.find((pretest) => pretest.id === id);

  return (
    <Drawer
      width={640}
      placement="right"
      closable={false}
      onClose={onClose}
      open={show}
    >
      <div>
        <div
          className="flex justify-between items-center"
          style={{ marginBottom: 18 }}
        >
          <p className="site-description-item-profile-p font-semibold uppercase">
            Pretest Questions and Answers{' '}
            {selectedPretest && `(${selectedPretest.candidate_name})`}
          </p>
        </div>
        {selectedPretest ? (
          <div key={selectedPretest.id}>
            <PretestResults
              user_id={selectedPretest.user_id}
              pretest_id={selectedPretest.id}
            />
          </div>
        ) : (
          <p className="text-center text-gray-500">
            No pretest data found for this user.
          </p>
        )}
      </div>
    </Drawer>
  );
};

export default DrawerPretest;
